<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-list nav dense height="100%" width="100%">
              <v-list-item-group>
                <v-list-item
                  v-for="item in headerLinks"
                  :key="item.title"
                  :to="item.to"
                >
                  <v-list-item-title v-if="item.show">
                    <v-icon class="pl-2">{{ item.icon }}</v-icon>
                    {{
                      $_t(`components.app.header.${item.title}`)
                    }}</v-list-item-title
                  >
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" md="4">
            <v-card dark height="100%" color="blue darken-1">
              <v-card-title class="justify-center">- خوش آمدید -</v-card-title>
              <router-link
                class="text-decoration-none white--text"
                :to="{ name: 'dashboard.certs' }"
              >
                <v-card-title class="justify-center">
                  <v-icon dark large class="pl-3"> mdi-account-circle </v-icon>
                  <span>برای درخواست مدرک کلیلک کنید</span>
                </v-card-title>
              </router-link>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card dark height="100%" color="blue-grey darken-2">
              <v-card-title class="justify-center warning black--text font-weight-bold py-2">اطلاعات مالی</v-card-title>
              <v-card-title class="text-break py-0">
                لطفا هزینه ی مدرک را به شماره کارت زیر ارسال کرده و فیش پرداختی
                را از بخش داشبورد و مدرک مورد نظر ارسال کنید با تشکر.
              </v-card-title>
              <v-card-title class="py-0 justify-space-between">
                {{ enToFa("6037998112962609") }}
                <span>به نام علی باغبان قراملکی</span>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-card height="100%">
          <v-container fluid>
            <router-view :key="$route.path"></router-view>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { enToFa } from "@/tools/Utils";

export default {
  name: "Dashboard.layout",
  computed: {
    ...mapGetters({
      user: "authentication/user",
    }),
    headerLinks() {
      return [
        {
          icon: "mdi-view-dashboard",
          title: "dashboard",
          to: { name: "dashboard.main" },
          show: !!this.user,
        },
        {
          icon: "mdi-new-box",
          title: "createCert",
          to: { name: "dashboard.certs" },
          show: !!this.user,
        },
        {
          icon: "mdi-home-account",
          title: "profile",
          to: { name: "dashboard.profile" },
          show: !!this.user,
        },
      ];
    },
  },
  methods: {
    enToFa,
  },
};
</script>

<style scoped></style>
